<template>
  <v-expand-transition>
    <v-btn
      v-if="scrollPosition > 100"
      fixed
      class="scroll-up-btn"
      width="40"
      height="40"
      min-width="40"
      elevation="0"
      @click="ScrollToTop"
    >
      <v-icon color="white">
        fa-angle-double-up
      </v-icon>
    </v-btn>
  </v-expand-transition>
</template>

<script>
import { useScrollPosition } from '../../utils/vue/useScrollPosition';
export default {
  name: 'scroll-to-top-button',
  data() {
    return {};
  },
  setup(props) {
    let { scrollPosition } = useScrollPosition(props.scrollableElementById);
    return { scrollPosition };
  },
  methods: {
    ScrollToTop() {
      document.getElementById(this.scrollableElementById).scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
  },
  props: {
    scrollableElementById: {
      type: String,
    },
  },
};
</script>
